import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComputerUse: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconComputerUse"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M10.75 16.75L7.75 7.75L16.75 10.75L12.25 12.25L10.75 16.75Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconComputerUse;
